<template>
  <div class="report-check-analytical">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="md"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-center"
          >
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6>SELECIONE O RESIDENTE</h6>
            <select
              v-model="resident_id"
              class="form-control"
              @input="handlePrescriptionsResident($event.target.value)"
            >
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div
            v-if="resident_id"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          >
            <h6>SELECIONE A PRESCRIÇÃO</h6>
            <div
              class="v-clean text-center p-2"
              v-if="group_prescription_medicines.length == 0"
            >
              RESIDENTE NÃO POSSUI PRESCRIÇÕES!
            </div>
            <b-overlay
              :show="loadingGroupPrescriptionMedicinesResident"
              opacity="0.99"
            >
              <select
                v-if="group_prescription_medicines.length > 0"
                v-model="group_prescription_medicine_id"
                class="form-control"
                @change="
                  handleChangeGroupPrescriptionMedicineId($event.target.value)
                "
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in group_prescription_medicines"
                  :key="value.id"
                  :value="value.id"
                >
                  {{
                    `${formatDate(value.start_date, false)} - ${formatDate(
                      value.end_date,
                      false
                    )}`
                  }}
                  -
                  {{ handleTypeGroupPrescription(value.type) }}
                </option>
              </select>
            </b-overlay>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6>MEDICAMENTOS</h6>
            <select v-model="medicine_type" class="form-control">
              <option value="ADMINISTRADOS">ADMINISTRADOS</option>
              <option value="NAO_ADMINISTRADOS">NÃO ADMINISTRADOS</option>
              <option value="TODOS">TODOS</option>
            </select>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0">
            <h6 class="upper-text mt-3 mb-1">Data inicial</h6>
            <input type="date" v-model="dtInit" class="form-control" />
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0">
            <h6 class="upper-text mt-3 mb-1">Data final</h6>
            <input type="date" v-model="dtEnd" class="form-control" />
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>

              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row filters">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-1"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: CHECAGEM DOS MEDICAMENTOS - ANALÍTICO
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="!group_prescription_medicine"
            @click="print"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean p-5 text-center"
          v-if="medicines.length == 0"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="medicines.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span
              ><strong>{{ resident.name }}</strong> |
            </span>
            <span>
              PRESCRIÇÃO:
              <strong>
                {{
                  `${formatDate(
                    group_prescription_medicine.start_date,
                    false
                  )} - ${formatDate(
                    group_prescription_medicine.end_date,
                    false
                  )}`
                }}
                -
                {{
                  handleTypeGroupPrescription(group_prescription_medicine.type)
                }}
              </strong>
              |
            </span>
            <span>
              <strong>MEDICAMENTOS</strong> {{ handleTypeMedicine() }}
            </span>
            <!-- <span
              ><strong>DATA INICIAL: {{ formatDate(dtInit, false) }} </strong>|
            </span>
            <span
              ><strong>DATA FINAL: {{ formatDate(dtEnd, false) }} </strong>|
            </span> -->
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <table class="table bg-white" v-if="medicines.length > 0">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 pb-0 pt-0"
                  >
                    <div class="row">
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-center text-center"
                      >
                        <img
                          v-if="rest_home_logo_url"
                          class="rest_home_logo_url"
                          :src="rest_home_logo_url"
                        />
                        <div v-if="!rest_home_logo_url" class="ml-1">
                          <strong class="text-uppercase">{{
                            rest_home_name
                          }}</strong>
                        </div>
                      </div>
                      <div
                        class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center"
                      >
                        <img
                          v-if="resident.photo_url"
                          class="resident_photo_url"
                          :src="resident.photo_url"
                        />
                        <img
                          v-if="!resident.photo_url"
                          class="resident_photo_url"
                          :src="require('../../../../assets/user.png')"
                        />
                        <div class="ml-3">
                          <h6 class="m-0">
                            {{ resident.name }}
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Data de nascimento:
                            {{ formatDate(resident.date_of_birth, false) }}
                            -
                            {{ getAge(resident.date_of_birth) }}
                            anos
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Data de admissão:
                            {{ formatDate(resident.date_of_reception, false) }}
                          </h6>
                          <h6
                            class="legends mb-1 worksansr"
                            v-if="resident.bed_id"
                          >
                            Leito Nº: {{ resident.bed_number }}, Andar:
                            {{ resident.bed_walk }}, ALA/Setor:
                            {{ resident.bed_ward_or_sector }}, Quarto:
                            {{ resident.bed_bedroom }}
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Cadastrado:
                            {{ formatDate(resident.created_at, false) }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-right"
                      >
                        <img class="logo" :src="logo" />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center"
                      >
                        <h6 class="mb-1">
                          CHECAGEM DOS MEDICAMENTOS - ANALÍTICO
                          <br />
                          PRESCRIÇÃO:
                          {{
                            `${formatDate(
                              group_prescription_medicine.start_date,
                              false
                            )} - ${formatDate(
                              group_prescription_medicine.end_date,
                              false
                            )}`
                          }}
                          -
                          {{
                            handleTypeGroupPrescription(
                              group_prescription_medicine.type
                            )
                          }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tr>
            <td>
              <div class="content">
                <div class="row border-bottom">
                  <div class="col-md-3 text-center">MEDICAMENTO</div>
                  <div class="col-md-3 text-center">ESTOQUE RETIRADO</div>
                  <div class="col-md-2 text-center">QUANTIDADE</div>
                  <div class="col-md-2 text-center">DATA</div>
                </div>
                <div
                  class="row item border-bottom"
                  v-for="(medicine, key) in medicines"
                  :key="key"
                >
                  <div class="col-md-3 pt-0 pb-0 text-center">
                    {{ medicine.medicine_name }}
                  </div>
                  <div class="col-md-3 pt-0 pb-0 text-center">
                    {{ medicine.stock_name }}
                  </div>
                  <div class="col-md-2 pt-0 pb-0 text-center">
                    {{
                      medicine.drops
                        ? `${medicine.drops} GOTA(S)`
                        : medicine.ui
                        ? `${medicine.ui} UI`
                        : medicine.quantity
                    }}
                    {{
                      medicine.drops
                        ? ""
                        : medicine.ui
                        ? ""
                        : `${medicine.unit_of_measurement_abbreviation}`
                    }}
                    <br />
                    <small
                      v-if="medicine.drops || medicine.ui"
                      class="text-muted"
                    >
                      {{ medicine.quantity }}
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </small>
                  </div>
                  <div class="col-md-2 pt-0 pb-0 text-center">
                    {{
                      medicine.created
                        ? `${formatDate(medicine.created, false)} - `
                        : ""
                    }}
                    {{
                      medicine.time == "null" || !medicine.time
                        ? `EVENTUAL`
                        : `${String(medicine.time).substr(0, 5)}`
                    }}
                  </div>
                  <div class="col-md-6 pt-0 pb-0 text-center">
                    Separado por <br />
                    (Assinatura eletrônica)
                    {{
                      professionalClassCouncilValue({
                        id: medicine.user_separate
                          .professional_class_council_id,
                        name: medicine.user_separate.name,
                        profile: medicine.user_separate.user_profile_name,
                        cpf: medicine.user_separate.cpf,
                        office: medicine.user_separate.office,
                        value:
                          medicine.user_separate
                            .professional_class_council_value,
                      })
                    }}
                    {{ formatDate(medicine.user_separate.created_at, false) }}
                    às
                    {{ formatTime(medicine.user_separate.created_at) }}
                  </div>
                  <div class="col-md-6 pt-0 pb-0 text-center">
                    Checado por <br />
                    (Assinatura eletrônica)
                    {{
                      professionalClassCouncilValue({
                        id: medicine.user_checked.professional_class_council_id,
                        name: medicine.user_checked.name,
                        profile: medicine.user_checked.user_profile_name,
                        cpf: medicine.user_checked.cpf,
                        office: medicine.user_checked.office,
                        value:
                          medicine.user_checked
                            .professional_class_council_value,
                      })
                    }}
                    {{ formatDate(medicine.user_checked.updated_at, false) }}
                    às
                    {{ formatTime(medicine.user_checked.updated_at) }}
                    <span v-if="medicine.check_anticipated == 1">
                      <i class="fas fa-clock icon-check-anticipated"></i>
                    </span>
                  </div>
                </div>
                <div class="text-center">
                  <hr class="border-black m-0" />
                  Gerado por
                  {{
                    professionalClassCouncilValue({
                      id: user.professional_class_council_id,
                      name: user.name,
                      profile: user.profile_name,
                      cpf: user.cpf,
                      office: user.office,
                      value: user.professional_class_council_value,
                    })
                  }}
                  <small>
                    - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                  </small>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../../../services/api";

import routes from "../../../../routes";

import {
  formatDate,
  formatTime,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import { getAge } from "../../../../lib/getAgeByDate";

import AuthBySessionExpired from "../../../Components/AuthBySessionExpired";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import NavBar from "../../../NavBar";

import { userData } from "../../../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsMedicineCheck",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },
  data() {
    return {
      resident_active: true,
      resident_not_active: false,
      group_prescription_medicine: false,
      group_prescription_medicine_filter: false,
      group_prescription_medicines: [],
      user: {},
      resident: {},
      residents: [],
      medicines: [],
      resident_id: "",
      group_prescription_medicine_id: "",
      dtInit: "",
      dtEnd: "",
      medicine_type: "ADMINISTRADOS",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
      loadingGroupPrescriptionMedicinesResident: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    formatTime,
    professionalClassCouncilValue,
    handleTypeGroupPrescription(type) {
      if (type == "LONGO_PRAZO") {
        return "LONGO PRAZO";
      }

      return "NORMAL";
    },
    handleTypeMedicine() {
      let { medicine_type } = this;

      let type = {
        ADMINISTRADOS: "ADMINISTRADOS",
        NAO_ADMINISTRADOS: "NÃO ADMINISTRADOS",
        TODOS: "TODOS",
      }[medicine_type];

      return type;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
    handleChangeGroupPrescriptionMedicineId(group_prescription_medicine_id) {
      this.group_prescription_medicine_id = group_prescription_medicine_id;
      this.group_prescription_medicine_filter = false;
      this.dtInit = "";
      this.dtEnd = "";

      if (group_prescription_medicine_id) {
        let { group_prescription_medicines } = this;

        let find = group_prescription_medicines.find(
          (group_prescription_medicine) =>
            group_prescription_medicine.id == group_prescription_medicine_id
        );

        if (find) {
          this.group_prescription_medicine_filter = find;

          let { start_date, end_date } = find;
          this.dtInit = moment(start_date).format("YYYY-MM-DD");
          this.dtEnd = moment(end_date).format("YYYY-MM-DD");
        }
      }
    },
    async retrieve() {
      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.getResidents();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handlePrescriptionsResident(resident_id) {
      if (resident_id) {
        try {
          this.loadingGroupPrescriptionMedicinesResident = true;

          let params = { resident_id };

          const response = await api.get(
            "/rest-home/resident/group-prescriptions",
            {
              params,
            }
          );

          const { error, errors, group_prescription_medicines } = response.data;

          if (error) {
            this.errors = errors;
          } else {
            this.group_prescription_medicines = group_prescription_medicines;
          }

          this.loadingGroupPrescriptionMedicinesResident = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const {
          resident_id,
          group_prescription_medicine_id,
          medicine_type,
          dtInit,
          dtEnd,
        } = this;

        let params = {
          resident_id,
          group_prescription_medicine_id,
          medicine_type,
          dtInit,
          dtEnd,
        };

        const response = await api.get(
          "/rest-home/resident/prescription-medicines-checked",
          {
            params,
          }
        );

        const {
          error,
          errors,
          resident,
          group_prescription_medicine,
          medicines,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = medicines;
          this.group_prescription_medicine = group_prescription_medicine;
          this.resident = resident;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
      routes;
      // let route = this.$router.resolve({
      //   name: "report_stock",
      //   params: {},
      // });

      // window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.report-check-analytical .logo {
  height: 50px;
  object-fit: contain;
}
.report-check-analytical table {
  width: 100%;
}
.report-check-analytical .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.report-check-analytical .resident_photo_url {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  object-fit: cover;
}
@media print {
  .report-check-analytical .table {
    page-break-after: always !important;
  }
  .report-check-analytical .item {
    page-break-inside: avoid !important;
  }
  .report-check-analytical .nav--bar {
    display: none;
  }
  .report-check-analytical .auth--by--session--expired {
    display: none;
  }
  .report-check-analytical .filters {
    display: none;
  }
  .report-check-analytical button {
    display: none;
  }
}
</style>
